export const PAYSERA_PAYMENT_STATUSES = {
  successful: 'success',
  failed: 'failed',
};

export const BANKLINK_PAYMENT_POLL_STATUSES = {
  success: 'SUCCESS',
  failed: 'FAILED',
  notFound: 'NOT_FOUND',
  pending: 'PENDING',
};
